import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/WholePotato.png";
import sliced from "../../assets/images/ingredients/potato_cut.png";

const Potato = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Potato"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Potato;